var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFbLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3948 30.7898C23.8971 30.7898 30.7895 23.8974 30.7895 15.3951C30.7895 6.89277 23.8971 0.000305176 15.3948 0.000305176C6.89247 0.000305176 0 6.89277 0 15.3951C0 23.8974 6.89247 30.7898 15.3948 30.7898Z",
    fill: "#43B4E9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5111 5.1319H17.0254C14.9569 5.1319 12.6562 5.95067 12.6562 8.77257C12.6663 9.75583 12.6562 10.6975 12.6562 11.7573H10.2632V15.3411H12.7302V25.6582H17.2635V15.273H20.2556L20.5264 11.7472H17.1854C17.1854 11.7472 17.1929 10.1788 17.1854 9.72334C17.1854 8.60819 18.4183 8.67205 18.4925 8.67205C19.0792 8.67205 20.2199 8.67366 20.5128 8.67205V5.1319H20.5111Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFbLogo);
export default __webpack_public_path__ + "static/media/fb-logo.827a7e9b8371e8ece2aac7b876073929.svg";
export { ForwardRef as ReactComponent };